module.exports = __webpack_public_path__ + "img/draft_list_icon.b2c4df8e.svg";